interface IntegrationDefinition {
  id: string;
  integrationType: string;
  integrationClass: string[];
  name: string;
}

interface IntegrationInstance {
  id: string;
  name: string;
  integrationDefinitionId: string;
}

const getIntegrationInstanceDisplayName = (
  instance: IntegrationInstance,
  definitions: IntegrationDefinition[]
) =>
  `(${
    definitions.find((d) => d.id === instance.integrationDefinitionId)?.name ||
    'unknown integration'
  }) ${instance.name}`;

export default getIntegrationInstanceDisplayName;
